/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Toolkit_BestInputs */

const en_pc_alt_t_toolkit_best = /** @type {(inputs: Pc_Alt_T_Toolkit_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Single-purpose jobs such as merge, split, compress and convert, plus a workflow editor`)
};

const zh_pc_alt_t_toolkit_best = /** @type {(inputs: Pc_Alt_T_Toolkit_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并、拆分、压缩、转换等单项任务，另有工作流编辑器`)
};

/**
* | output |
* | --- |
* | "Single-purpose jobs such as merge, split, compress and convert, plus a workflow editor" |
*
* @param {Pc_Alt_T_Toolkit_BestInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_toolkit_best = /** @type {((inputs?: Pc_Alt_T_Toolkit_BestInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Toolkit_BestInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_toolkit_best(inputs)
	return zh_pc_alt_t_toolkit_best(inputs)
});
export { pc_alt_t_toolkit_best as "pc.alt.t.toolkit.best" }